import { Flex, Form, Input } from "antd"
import { useTranslation } from "react-i18next"
import { colors, spacings } from "themes/variables"
import { Icon } from "ui/Icon"
import { TextArea } from "ui/Input"
import { Text } from "ui/Typography"

const PriceAndReasonFields = () => {
  const { t } = useTranslation()
  return (
    <>
      <Form.Item label={t("client.client_booking.enter_new_price")}>
        <Form.Item
          name="amount"
          noStyle
          rules={[
            { required: true, message: t("client.client_booking.new_price_is_required") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject()
                }
                const numericValue = parseFloat(value)
                if (isNaN(numericValue)) {
                  return Promise.reject(new Error(t("client.client_booking.new_price_must_be_a_valid_number")))
                }
                if (numericValue <= 0) {
                  return Promise.reject(new Error(t("client.client_booking.new_price_must_be_greater_than_zero")))
                }
                return Promise.resolve()
              }
            })
          ]}
        >
          <Input placeholder={t("client.client_booking.enter_new_price")} prefix="$" type="number" />
        </Form.Item>
      </Form.Item>
      <Form.Item label="Reason*">
        <Form.Item
          name="reason"
          noStyle
          rules={[
            { required: true, message: t("client.client_booking.reason_is_required") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject()
                }
                return Promise.resolve()
              }
            })
          ]}
        >
          <TextArea placeholder={t("client.client_booking.enter_the_reason")} />
        </Form.Item>
      </Form.Item>
      <Flex gap={spacings.S} style={{ backgroundColor: colors.surface1 }} className="py-xs px-s" align="center">
        <Icon type="feather" name="Info" width={20} height={20} />
        <Text size="lg" color={colors.textPrimary}>
          {t("client.client_booking.reason_info")}
        </Text>
      </Flex>
    </>
  )
}

export default PriceAndReasonFields
